import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>if statement in c tutorial For Beginners</title>
 <meta name="description" content="if statement in c tutorial for beginners.If is used for making a decision.If and else can be a block statementCodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,if in c programming,if,in in c,if statement in c,c programming if statement" />
 <link rel="canonical" href="https://www.codeexampler.com/c-if"/>
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">if statement in c
 </h1>
 <div className="first">
        <a href="/c-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">If is used for making a decision.
If and else can be a block statement
</p>


<h2 className='headings'>if statement in C Syntax :</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight: "500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-10">conditon</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" > &#123; </span>
            {"\n"}
                  <span className="qwerty-3">   body</span>
                  {"\n"}
                <span className="qwerty-4" > &#125;</span>       
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>                
  



<h2 className='headings'>Q-Write a program to input a number and check this number is more than or equal to 100?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight: "500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-4" > &#123; </span>
            {"\n"}{"\n"}
                  <span className="qwerty-3">    int</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">;</span>
                {"\n"}{"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">Enter a number</span>
                <span className="qwerty-4">"</span>
                <span className="qwerty-4">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">   scanf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">%d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-3">&</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">);</span>
            {"\n"}{"\n"}
                <span className="qwerty-6">   if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-3">&#62;=</span>
                <span className="qwerty-1"> 100 </span>
                <span className="qwerty-4">) </span>
                {"\n"}{"\n"}
            <span className="qwerty-4" >   &#123;</span>       
            {"\n"}{"\n"}
            <span className="qwerty-8">     printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">that no is greater than 100</span>
                <span className="qwerty-4">"</span>
                <span className="qwerty-4">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-4" >   &#125;</span>       
            {"\n"}{"\n"}
                <span className="qwerty-7" >    return</span>  
                <span className="qwerty-3" > 0</span>  
                <span className="qwerty-4">;</span>          
            {"\n"}{"\n"}
            <span className="qwerty-4" >&#125;</span>       
            {"\n"}{"\n"}
               
                 </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    
                    {"\n"}
                        <span className="qwerty-3">Enter a number </span>                   
                        <span className="qwerty-2">450</span>
                    {"\n"}{"\n"}
                        <span className="qwerty-3">that no is greater than 100</span>                 
                        {"\n"}{"\n"}
                </code>
                </pre>
                </div>


<p className="mt-4 para">If you don't know about input in C so check on the <a href="https://www.codeexampler.com/c-input">C input tutorial</a>.</p>




<h2 className='headings'>Q-Write a program to input a number and check greater and lesser no?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight: "500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}{"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}{"\n"}
                 <span className="qwerty-4" > &#123; </span>
             {"\n"}{"\n"}
                   <span className="qwerty-3">    int</span>
                 <span className="qwerty-5"> a</span>
                 <span className="qwerty-4">;</span>
                 {"\n"}{"\n"}
                 <span className="qwerty-8">   printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">Enter a value of a \n</span>
                 <span className="qwerty-4">"</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-6">   scanf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">%d</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-3">&</span>
                 <span className="qwerty-5">a</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
                 <span className="qwerty-6">   if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5"> a</span>
                 <span className="qwerty-3">&#62;=</span>
                 <span className="qwerty-1"> 500 </span>
                 <span className="qwerty-4">) </span>
                 {"\n"}{"\n"}
             <span className="qwerty-4" >   &#123;</span>       
             {"\n"}{"\n"}
             <span className="qwerty-8">     printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">a %d is greater than 500</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-4" >   &#125;</span>       
             {"\n"}{"\n"}             
                 <span className="qwerty-6">   if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5"> a</span>
                 <span className="qwerty-3">&#60;</span>
                 <span className="qwerty-1"> 500 </span>
                 <span className="qwerty-4">) </span>
                 {"\n"}{"\n"}
             <span className="qwerty-4" >   &#123;</span>       
             {"\n"}{"\n"}
             <span className="qwerty-8">     printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">a %d is less than 500</span>
                 <span className="qwerty-4">",</span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-4" >   &#125;</span>       
             {"\n"}{"\n"}
                 <span className="qwerty-7" >    return</span>  
                 <span className="qwerty-3" > 0</span>  
                 <span className="qwerty-4">;</span>          
             {"\n"}{"\n"}
             <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >
                     
                     {"\n"}
                         <span className="qwerty-3">Enter a value of  </span>                   
                         <span className="qwerty-4">a</span>
                     {"\n"}{"\n"}
                         <span className="qwerty-2">450</span>
                     {"\n"}{"\n"}
                         <span className="qwerty-3">a</span>
                         <span className="qwerty-2"> 450</span>
                         <span className="qwerty-3"> is less than </span>                 
                         <span className="qwerty-2">500</span>
                         {"\n"}{"\n"}
                 </code>
                 </pre>
                 </div>




<h2 className='headings'>Q-Write a program to input a number and check no is greater or lesser?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight: "500vh"}}>
           <code >
             {"\n"}{"\n"}
                 <span className="qwerty-7">#include </span>
                 <span className="qwerty-4">&#60;</span>
                 <span className="qwerty-10">stdio.h</span>
                 <span className="qwerty-4">&#62; </span>
             {"\n"}{"\n"}
                 <span className="qwerty-3">int </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-4"> ()</span>
             {"\n"}{"\n"}
                 <span className="qwerty-4" > &#123; </span>
             {"\n"}{"\n"}
                   <span className="qwerty-3">    int</span>
                 <span className="qwerty-5"> a</span>
                 <span className="qwerty-4">,</span>
                 <span className="qwerty-5"> b</span>
                 <span className="qwerty-4">,</span>
                 <span className="qwerty-5"> c</span>
                 <span className="qwerty-4">;</span>               
                 {"\n"}{"\n"}
                 <span className="qwerty-5">   a </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-1"> 100</span>
                 <span className="qwerty-4">;</span>
                 <span className="qwerty-5"> b </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-1"> 200</span>
                 <span className="qwerty-4">;</span>
                 <span className="qwerty-5"> c </span>
                 <span className="qwerty-4">=</span>
                 <span className="qwerty-1"> 400</span>
                 <span className="qwerty-4">;</span>
             {"\n"}{"\n"}
                 <span className="qwerty-6">   if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5"> a</span>
                 <span className="qwerty-3">&#62;</span>
                 <span className="qwerty-5">b </span>
                 <span className="qwerty-4">) </span>
                 {"\n"}{"\n"}
             <span className="qwerty-4" >   &#123;</span>       
             {"\n"}{"\n"}
             <span className="qwerty-8">     printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">a is greater than b \n</span>
                 <span className="qwerty-4">"</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-4" >   &#125;</span>       
             {"\n"}{"\n"}
                 <span className="qwerty-6">   if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5"> b</span>
                 <span className="qwerty-3">&#62;</span>
                 <span className="qwerty-5">a </span>
                 <span className="qwerty-4">) </span>
                 {"\n"}{"\n"}
             <span className="qwerty-4" >   &#123;</span>       
             {"\n"}{"\n"}
             <span className="qwerty-8">     printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">b is greater than a \n</span>
                 <span className="qwerty-4">"</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-4" >   &#125;</span>       
             {"\n"}{"\n"}
                 <span className="qwerty-6">   if </span>
                 <span className="qwerty-4">(</span>
                 <span className="qwerty-5"> c</span>
                 <span className="qwerty-3">&#62;</span>
                 <span className="qwerty-5">a </span>
                 <span className="qwerty-4">) </span>
                 {"\n"}{"\n"}
             <span className="qwerty-4" >   &#123;</span>       
             {"\n"}{"\n"}
             <span className="qwerty-8">     printf</span>
                 <span className="qwerty-4">("</span>
                 <span className="qwerty-2">c is greater than a \n</span>
                 <span className="qwerty-4">"</span>
                 <span className="qwerty-4">);</span>
             {"\n"}{"\n"}
             <span className="qwerty-4" >   &#125;</span>       
             {"\n"}{"\n"}
                 <span className="qwerty-7" >    return</span>  
                 <span className="qwerty-3" > 0</span>  
                 <span className="qwerty-4">;</span>          
             {"\n"}{"\n"}
             <span className="qwerty-4" >&#125;</span>       
             {"\n"}{"\n"}
                
                  </code>
         </pre>
         </div>          
         <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
           <pre style={{maxHeight:"100vh"}}>
                 <code >
                     
                     {"\n"}{"\n"}
                         <span className="qwerty-4">b</span> 
                         <span className="qwerty-3"> is greater than </span>
                         <span className="qwerty-4">a</span>                  
                     {"\n"}{"\n"}
                         <span className="qwerty-4">c</span> 
                         <span className="qwerty-3"> is greater than </span>
                         <span className="qwerty-4">a</span>                      
                         {"\n"}{"\n"}
                 </code>
                 </pre>
                 </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cif;